import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AuthService } from './services/auth.service';
import { UserService } from './services/user.service';
import { HttpService } from './services/http.service';
import { UtilService } from './services/util.service';
import { StorageService } from './services/storage.service';
import { EnumService } from './services/enum.service';
import { PreferencesService } from './services/preferences.service';
import { MetaDataService } from './services/meta-data.service';

import { HttpSetParamProvider } from './implements/setParam.interceptor';
import { HttpAuthProvider } from './implements/auth.interceptor';
import { RouterReuseStrategyProvider } from './implements/configurable.routerReuseStrategy';
import { LoadMarkedPreloadStrategy } from './implements/loadMarked.preloadStrategy';
import './public/rx.import';
import { ScrollService } from './services/scroll.service';

@NgModule({
    imports: [
        HttpClientModule
    ],
    providers: [
        UserService, AuthService,
        HttpService, UtilService,
        StorageService, EnumService,
        PreferencesService, MetaDataService,
        RouterReuseStrategyProvider,
        HttpSetParamProvider, HttpAuthProvider,
        ScrollService,
        LoadMarkedPreloadStrategy
    ]
})
export class CoreModule {

    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        if (parentModule) {
            throw new Error(
                'CoreModule is already loaded. Import it in the AppModule only');
        }
    }

    static forRoot(): ModuleWithProviders {
        return {
            ngModule: CoreModule,
            providers: [
                // { provide: UserServiceConfig, useValue: config }
            ]
        };
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/core/core.module.ts